import React from 'react';
import GolfCompleteContainer from '../components/organisms/golfCompleteContainer';
import { GolfHeaderContainer } from '../components/organisms/golfHeaderContainer';
import common from "../resources/js/common/common"
import { golfReservationList } from '../const';
import GolfReservationPopupContainer from '../components/organisms/golfReservationPopupContainer';
class GolfCancel extends React.Component {

    constructor(props) {
        super(props);
        this.state = { 
            popupDataList: [],
            golfReservationPopup : false,
        };
    };

    render() {

        // モーダルClose
        const onClickClosePopupWindow = () => { this.setState({ golfReservationPopup: false }); };

        // 予約確認モーダル
        const onClickOpenReservationPopupWindow = (loginId) => {
            this.setState({
                golfReservationPopup: true,
            });

            common.doPost(golfReservationList, { userId : loginId }, afterConfirmGolfReservation);
        }

        // 予約情報取得後処理
        const afterConfirmGolfReservation = (res) => {
            if (res.data.resultCode !== 0) {

            } else {
                this.setState(
                    {
                        popupDataList: res.data.Data,
                    }
                );
            }
        }

        return (
            <div>
                <GolfHeaderContainer 
                    Label categoryLabel1={"キャンセル完了"} 
                    categoryLabel2={"CANCELED"} 
                    onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}    
                />
                <GolfReservationPopupContainer
                    state={this.state}
                    onClickClosePopupWindow={onClickClosePopupWindow}
                />
                <GolfCompleteContainer
                    completeTitle={"キャンセルを承りました"} 
                    completeBody={""}
                    completeBody2={""}
                    dispName={"cancel"}/>
            </div>
        )
    }
}
export default GolfCancel;